import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import {
  AuthLayout, ErrorText, useAuthConfig, passwordMeetsPolicy, PasswordHints,
  input, label, button, linkRow, linkStyle,
} from './authShared';

/** Complete a password reset with the emailed code and a new password. The code
 *  is trimmed client-side too — belt-and-suspenders on the whitespace bug. */
export default function ResetPassword() {
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !code.trim()) { setError('Enter your email and the code.'); return; }
    if (!passwordMeetsPolicy(password, cfg?.passwordPolicy)) {
      setError('Please choose a password that meets the requirements above.'); return;
    }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    const r = await AuthAPI.resetPassword(email.trim(), code.trim(), password);
    setBusy(false);
    if (r.ok && r.status === 'ok') { nav('/login?reset=1'); return; }
    setError(r.message || 'That code is invalid or has expired.');
  };

  return (
    <AuthLayout title="Set a new password" subtitle="Enter the code we emailed and choose a new password.">
      <form onSubmit={submit}>
        <label style={label}>Email
          <input style={input} type="email" value={email} onChange={e => setEmail(e.target.value)} />
        </label>
        <label style={label}>Reset code
          <input style={input} inputMode="numeric" autoComplete="one-time-code" value={code}
                 onChange={e => setCode(e.target.value)} autoFocus />
        </label>
        <label style={label}>New password
          <input style={input} type="password" autoComplete="new-password" value={password}
                 onChange={e => setPassword(e.target.value)} />
        </label>
        <PasswordHints policy={cfg?.passwordPolicy} />
        <label style={label}>Confirm new password
          <input style={input} type="password" autoComplete="new-password" value={confirm}
                 onChange={e => setConfirm(e.target.value)} />
        </label>
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Saving…' : 'Reset password'}</button>
      </form>
      <p style={linkRow}><Link to="/login" style={linkStyle}>Back to sign in</Link></p>
    </AuthLayout>
  );
}
